import { useState } from "react";

import {
  ActionIcon,
  Affix,
  Box,
  Button,
  Divider,
  Group,
  HoverCard,
  Modal,
  MultiSelect,
  Text,
  TextInput,
  Title
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconPlus, IconRefresh } from "@tabler/icons-react";

import { CustomPagination } from "../components/pagination/CustomPagination.tsx";
import { SendersTable } from "../components/tables/SendersTable.tsx";
import { MAX_VARCHAR_LENGTH } from "../constants/constants.ts";
import { senderStatusArray } from "../enums/SenderStatus.ts";
import { useError } from "../hooks/useError.ts";
import { useSenders } from "../hooks/useSenders.ts";
import { useSenderMutation } from "../mutations/useSenderMutation.ts";
import { ErrorPage } from "./ErrorPage.tsx";

export const SendersPage = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const { senders, isLoading, queryError, isError, statuses, setStatuses } = useSenders(
    currentPage,
    ["UNAUTHORIZED", "ACTIVE"]
  );
  const { errorMessage } = useError(queryError);
  const { saveSenderMutation, refreshSendersMutation } = useSenderMutation();
  const [senderEmail, setSenderEmail] = useState("");
  const [openedCreationModal, { open, close }] = useDisclosure(false);

  const createSender = (email: string) => {
    saveSenderMutation.mutate(email);
    close();
  };
  const refreshSenders = () => {
    refreshSendersMutation.mutate();
  };
  return isError ? (
    <ErrorPage
      code={errorMessage.code}
      title={errorMessage.title}
      description={errorMessage.description}
    />
  ) : (
    <>
      <Box style={{ display: "flex", alignItems: "center", zIndex: 1 }}>
        <Title>Senders</Title>
        <Box
          style={{
            marginLeft: "89.7%",
            alignItems: "center"
          }}
        >
          <HoverCard shadow="md" openDelay={500}>
            <HoverCard.Target>
              <ActionIcon
                onClick={refreshSenders}
                style={{ float: "right" }}
                className={"secondary-button"}
              >
                <IconRefresh />
              </ActionIcon>
            </HoverCard.Target>
            <HoverCard.Dropdown>
              <Text size="sm">Refresh statuses from Mailjet.</Text>
            </HoverCard.Dropdown>
          </HoverCard>
        </Box>
      </Box>

      <Divider />
      <Box style={{ marginLeft: "70%", marginTop: "1%" }}>
        <MultiSelect
          checkIconPosition="right"
          data={senderStatusArray}
          value={statuses}
          onChange={setStatuses}
          placeholder={statuses.length == 0 ? "Filter by status" : ""}
        />
      </Box>
      <Box mx="auto">
        <Modal
          opened={openedCreationModal}
          onClose={close}
          withCloseButton={false}
          title={"Create new sender"}
          yOffset={200}
        >
          <Text size={"xs"}>You will receive a mail to validate the address.</Text>
          <TextInput
            label=""
            placeholder={"Sender's email address"}
            value={senderEmail}
            maxLength={MAX_VARCHAR_LENGTH}
            onChange={(event) => setSenderEmail(event.target.value)}
          />
          <Group justify={"right"}>
            <Button mt={"md"} variant={"default"} onClick={close}>
              cancel
            </Button>
            <Button mt={"md"} onClick={() => createSender(senderEmail)}>
              submit
            </Button>
          </Group>
        </Modal>
        <SendersTable senders={senders} isLoading={isLoading} />
        <CustomPagination
          totalPages={senders?.totalPages ?? 0}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
        <Affix style={{ zIndex: 2 }} position={{ bottom: 80, right: 80 }}>
          <ActionIcon radius="xl" size={50} onClick={open}>
            <IconPlus stroke={1.5} size={30} />
          </ActionIcon>
        </Affix>
      </Box>
    </>
  );
};
